<template>
  <ul class="filter-keywords-list">
    <li v-for="(word, index) in keywords" :key="index"
        class="keyword">
      <div class="one-liner">{{ word | customFiltersPhrases }}</div>
      <icon-cross width="24"
                  height="24"
                  color="#b9b9b9"
                  class="btn-close"
                  @click="$emit('deleteKeyword', index)" />
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      keywords: {
        type: Array,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .filter-keywords-list {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    list-style: none;

    .keyword {
      width: 100%;
      height: 50px;
      padding: 0 3px 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f2f2f2;

      .btn-close {
        cursor: pointer;
        min-width: 24px;
        min-height: 24px
      }
    }
  }
</style>